/**
 * DASHBOARD_V2 feature flag (client-side, founder-gated).
 *
 * Enabled when ANY of these are true:
 *   • URL param `?v2=1` (persists to localStorage)
 *   • URL param `?v2=0` (clears)
 *   • localStorage `vault.dashboard_v2 === "1"`
 *
 * Founder/Super Admin sees a "Try Command Centre v2" pill on the classic
 * dashboard. Nothing changes for other users until they explicitly opt in.
 */
const LS_KEY = "vault.dashboard_v2";

function readParam() {
    if (typeof window === "undefined") return null;
    const p = new URLSearchParams(window.location.search);
    if (!p.has("v2")) return null;
    return p.get("v2") === "1";
}

export function isDashboardV2Enabled() {
    if (typeof window === "undefined") return false;
    const q = readParam();
    if (q === true) {
        try { window.localStorage.setItem(LS_KEY, "1"); } catch { /* ignore */ }
        return true;
    }
    if (q === false) {
        try { window.localStorage.removeItem(LS_KEY); } catch { /* ignore */ }
        return false;
    }
    try { return window.localStorage.getItem(LS_KEY) === "1"; }
    catch { return false; }
}

export function setDashboardV2(on) {
    if (typeof window === "undefined") return;
    try {
        if (on) window.localStorage.setItem(LS_KEY, "1");
        else window.localStorage.removeItem(LS_KEY);
    } catch { /* ignore */ }
}
